export default {
  CLEAR_ERROR_STORE(state) {
    state.errors = [];
  },
  CHANGE_ERROR(state, payload) {
    state.errors = [payload];
  },
};
